export const getTestUrl = (component: string, testName: string, theme: "web" | "responsive" = "web") => {
    return `components/${component}/test/${theme}/${component}.${testName}.e2e.html`;
};
